import type { HoldList } from 'api-client/models';

export const isHoldActionable = (hold: Pick<HoldList, 'status'>): boolean =>
  hold.status === 'pending' || hold.status === 'challenged';

export const isHoldDetailSelectable = (hold: HoldList): boolean =>
  isHoldActionable(hold) || hold.status === 'confirmed';
